import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionsButtonsComponent } from '../../../../Components';
import { DevelopersPermissions } from '../../../../Permissions';
import {
  DevelopersAdvanceSearch,
  DevelopersCreatedOnFilter,
  DevelopersFiltersComponent,
} from '../DevelopersViewComponent';
import { ActionsButtonsEnum } from '../../../../Enums';
import { returnPropsByPermissions } from '../../../../Helper';

export const DevelopersContactsHeaderView = ({
  parentTranslationPath,
  translationPath,
  dateFilter,
  setDateFilter,
  setIsDatePickerChanged,
  isLoading,
  advanceSearch,
  setActiveActionType,
  activeActionType,
  onFilterValuesChanged,
  filterValuesFromAdvanceSearch,
  setOrderBy,
  formId,
  setFilterSearchDto,
  setDevelopersTableFilter,
  setFilterValuesFromAdvanceSearch,
  setActionButtonsKey,
  orderFilter,
  setIsClearFiltersClicked,
  dateRangeDefault,
  setSearchData,
  activeSelectedAction,
  closeTypeDialogHandler,
  selectedOrderBy,
  setSearchedItem,
  setSelectedOrderBy,
  setIsAdvanceSearchActive,
  isAdvanceSearchActive,
  setActiveFormType,
  orderBy,
  allFormFields,
  isAllFormFieldsLoading,
  selectFieldsOnAdvanceSearch,
  setSelectFieldsOnAdvanceSearch,
  isDisplayDevelopersData,
  changeContactClass,
  developerContactClasses,
  developerContactClassesFilter,
  selectedValuesInFilters,
  setSelectedValuesInFilters,
  setContactClasses,
  filterValues,
  setFilterValues,
  setIsAdvanceSearchCleared,
  isAdvanceSearchCleared,
  setDeveloperContactClassesFilter,
  setIsOpenAddDeveloperDialog,
  setIsImportDialogOpen,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const [activeAction, setActiveAction] = useState(ActionsButtonsEnum[1].id);

  function onActionsButtonClicked() {
    if (activeAction === ActionsButtonsEnum[1].id) {
      setIsOpenAddDeveloperDialog(true);
    } else if (activeAction === ActionsButtonsEnum[3].id) {
      setIsImportDialogOpen(true);
    }
  }

  function onActionButtonChanged(activeAction) {
    setActiveAction(activeAction);
  }

  return (
    <div className='d-flex-column'>
      <div className='header-section'>
        <div className='filter-section'>
          <div className='section'>
            <ActionsButtonsComponent
              isDisabled={false}
              addPermissionsId={
                DevelopersPermissions.CreateNewDeveloper.permissionsId
              }
              enableImport
              onActionsButtonClicked={onActionsButtonClicked}
              onActionButtonChanged={onActionButtonChanged}
            />
          </div>
          {isDisplayDevelopersData && (
            <div className='section autocomplete-section'>
              <DevelopersFiltersComponent
                translationPath={translationPath}
                parentTranslationPath={parentTranslationPath}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                dateRangeDefault={dateRangeDefault}
                setIsDatePickerChanged={setIsDatePickerChanged}
                isLoading={isLoading}
                setIsAdvanceSearchActive={setIsAdvanceSearchActive}
                changeContactClass={changeContactClass}
                developerContactClasses={developerContactClasses}
                developerContactClassesFilter={developerContactClassesFilter}
                selectedValuesInFilters={selectedValuesInFilters}
                setSelectedValuesInFilters={setSelectedValuesInFilters}
                filterValues={filterValues}
                setFilterValues={setFilterValues}
                isAdvanceSearchCleared={isAdvanceSearchCleared}
                setDeveloperContactClassesFilter={
                  setDeveloperContactClassesFilter
                }
              />

              <DevelopersAdvanceSearch
                translationPath={translationPath}
                parentTranslationPath={parentTranslationPath}
                advanceSearch={advanceSearch}
                setActiveActionType={setActiveActionType}
                activeActionType={activeActionType}
                onFilterValuesChanged={onFilterValuesChanged}
                filterValuesFromAdvanceSearch={filterValuesFromAdvanceSearch}
                setOrderBy={setOrderBy}
                formId={formId}
                setFilterSearchDto={setFilterSearchDto}
                setDevelopersTableFilter={setDevelopersTableFilter}
                setSelectedOrderBy={setSelectedOrderBy}
                setIsAdvanceSearchActive={setIsAdvanceSearchActive}
                isAdvanceSearchActive={isAdvanceSearchActive}
                setFilterValuesFromAdvanceSearch={
                  setFilterValuesFromAdvanceSearch
                }
                setActiveFormType={setActiveFormType}
                orderFilter={orderFilter}
                setActionButtonsKey={setActionButtonsKey}
                setIsClearFiltersClicked={setIsClearFiltersClicked}
                dateRangeDefault={dateRangeDefault}
                setSearchData={setSearchData}
                setSearchedItem={setSearchedItem}
                setDateFilter={setDateFilter}
                activeSelectedAction={activeSelectedAction}
                closeTypeDialogHandler={closeTypeDialogHandler}
                allFormFields={allFormFields}
                isAllFormFieldsLoading={isAllFormFieldsLoading}
                selectFieldsOnAdvanceSearch={selectFieldsOnAdvanceSearch}
                setSelectFieldsOnAdvanceSearch={setSelectFieldsOnAdvanceSearch}
                setSelectedValuesInFilters={setSelectedValuesInFilters}
                setContactClasses={setContactClasses}
                setFilterValues={setFilterValues}
                isAdvanceSearchCleared={isAdvanceSearchCleared}
                setIsAdvanceSearchCleared={setIsAdvanceSearchCleared}
                setDeveloperContactClassesFilter={
                  setDeveloperContactClassesFilter
                }
              />
            </div>
          )}
        </div>
        {isDisplayDevelopersData && (
          <DevelopersCreatedOnFilter
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            orderFilter={orderFilter}
            selectedOrderBy={selectedOrderBy}
            setOrderBy={setOrderBy}
            setSelectedOrderBy={setSelectedOrderBy}
            orderBy={orderBy}
            formId={formId}
          />
        )}
      </div>
    </div>
  );
};
